import React from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import {
	connect
} from 'react-redux'
import FieldGroup from '../components/common/FieldGroup.jsx';
import FittingBatchEditComponent from '../components/FittingBatchEditComponent.jsx';
import {
	findAllFirefighterTypes,
	changeFittingBatchValue,
	addBatchItems,
} from '../actions';
import {
	colorDisplay, sizingDisplay
} from '../constants/common';

function generateFittingBatchRows(batch, batchValidation, detailsNeedBespoke, setValue) {
	let fittingBatchRows = null;
	if (batch.get('batchBespokeDetail') && batch.get('batchBespokeDetail').get('order_detail_id') && !('' === batch.get('batchBespokeDetail').get('order_detail_id'))) {
		let bd = batch.get('batchBespokeDetail');
		let _color = "_color";
		let _sizing = "_sizing";
		let _note = "_note";
		let colorArray = [];
		let sizeArray = [];
		if (bd.get('color_values')) {
			colorArray = bd.get('color_values').split(",");
		}
		if (bd.get('size_values')) {
			sizeArray = bd.get('size_values').split(",");
		}
		let noteLabel = bd.get('customer_gear_name') + "備註";
		fittingBatchRows = (
			<div>
				<FormGroup>
					<ControlLabel>{bd.get('customer_gear_name')}顏色</ControlLabel><br />
					{
						colorArray.map((colorValue, key) => (
							<span key={_color + '_' + key}><input type="radio" name={_color} value={colorValue} onChange={(event) => { setValue(_color, event.target.value) }} checked={batch.get(_color) === colorValue} />{colorDisplay(colorValue)}</span>
						))
					}
				</FormGroup>
				<FormGroup>
					<ControlLabel>{bd.get('customer_gear_name')}尺寸</ControlLabel><br />
					{
						sizeArray.map((sizeValue, key) => (
							<span key={_sizing + '_' + key}><input type="radio" name={_sizing} value={sizeValue} onChange={(event) => { setValue(_sizing, event.target.value) }} checked={batch.get(_sizing) === sizeValue} />{sizingDisplay(sizeValue)}</span>
						))
					}
				</FormGroup>
				<FieldGroup id={_note}
					type="text"
					label={noteLabel}
					value={batch.get(_note)}
					onChange={(id, value) => {
						setValue(id, value);
					}}
					validation={batchValidation.get(_note)}
				/>
			</div>
		);
	}
	return fittingBatchRows;
}

function clickIsSpareParts(batch, setValue) {
	if (batch.get('isSpareParts')) {
		setValue('isSpareParts', false);
	} else {
		setValue('isSpareParts', true);
	}
}

const mapStateToProps = (state) => ({
	batch: state.getIn(['fittingReducer', 'batch']),
	batchValidation: state.getIn(['fittingReducer', 'batchValidation']),
	allFirefighterTypes: state.getIn(['commonReducer', 'allFirefighterTypes']),
	alertStyle: state.getIn(['fittingReducer', 'alertStyle']),
	alertMessage: state.getIn(['fittingReducer', 'alertMessage']),
	detailsNeedBespoke: state.getIn(['fittingReducer', 'detailsNeedBespoke']),

	activePage: state.getIn(['fittingBatchListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingBatchListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	addBatchItems: (batch, pagingData) => {
		dispatch(addBatchItems(batch, pagingData));
	},
	findAllFirefighterTypes: () => {
		dispatch(findAllFirefighterTypes());
	},
	setValue: (id, value) => {
		dispatch(changeFittingBatchValue({
			id: id,
			value: value
		}))
	},
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	batch: stateProps.batch,
	batchValidation: stateProps.batchValidation,
	allFirefighterTypes: stateProps.allFirefighterTypes,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	detailsNeedBespoke: stateProps.detailsNeedBespoke,
	fittingBatchRows: generateFittingBatchRows(stateProps.batch, stateProps.batchValidation, stateProps.detailsNeedBespoke, dispatchProps.setValue),

	addBatchItems: () => dispatchProps.addBatchItems(stateProps.batch, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}),
	findAllFirefighterTypes: dispatchProps.findAllFirefighterTypes,
	setValue: dispatchProps.setValue,
	clickIsSpareParts: () => {
		clickIsSpareParts(stateProps.batch, dispatchProps.setValue);
	},
})

const FittingBatchEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(FittingBatchEditComponent)

export default FittingBatchEditContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingBatchEditContainer.jsx